<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Vendor Name</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Loyalty Point System</b>
      /
      <router-link :to="{ name: 'vendor-view' }">Vendor List</router-link>
      /
      <b>Product List</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12">
        <h4>
          <b>Vendor: {{ vendor_name }}</b>
        </h4>
      </div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group" role="group">
          <button
            class="btn btn-secondary"
            id="btn-pending"
            type="button"
            :class="{ 'change-background': activeClick }"
            @click="pending1()"
          >
            Pending
          </button>
          <button
            class="btn btn-secondary"
            id="btn-approved"
            type="button"
            :class="{ 'change-background': !activeClick }"
            @click="approved1()"
          >
            Approved
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <br />
        <!-- List of pending product -->
        <div class="card text-left">
          <div class="card-body">
            <div id="pending_card">
              <h4 class="card-title mb-3"><b>Pending Product</b></h4>
              <div class="table-responsive">
                <table
                  id="pending_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Image</th>
                      <th>Description</th>
                      <th>Remarks</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      <th>TBM Point</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in pendings" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ data.name }}</td>
                      <td>
                        <div v-for="(img, i) in src" :key="i">
                          <img
                            v-if="img.id == data.id"
                            :src="img.src"
                            style="height: 60px"
                          />
                        </div>
                      </td>
                      <td>{{ data.description }}</td>
                      <td>{{ data.remarks }}</td>
                      <td>{{ data.quantity }}</td>
                      <td>{{ data.price }}</td>
                      <td>{{ data.point }}</td>
                      <td>
                        <router-link
                          :to="redirect(data.id)"
                          type="button"
                          class="btn btn-primary btn-rounded btn-block"
                          >View Details</router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div id="approved_card" class="d-none">
              <h4 class="card-title mb-3"><b>Approved Product</b></h4>
              <div class="table-responsive">
                <table
                  id="approved_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Image</th>
                      <th>Description</th>
                      <th>Remarks</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      <th>TBM Point</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in approved" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ data.name }}</td>
                      <td>
                        <div v-for="(img, i) in src" :key="i">
                          <img
                            v-if="img.id == data.id"
                            :src="img.src"
                            style="height: 60px"
                          />
                        </div>
                      </td>
                      <td>{{ data.description }}</td>
                      <td>{{ data.remarks }}</td>
                      <td>{{ data.quantity }}</td>
                      <td>{{ data.price }}</td>
                      <td>{{ data.point }}</td>
                      <td>
                        <router-link
                          :to="redirect(data.id)"
                          type="button"
                          class="btn btn-primary btn-rounded btn-block"
                          >View Details</router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "vendor_view",
  components: {},

  data() {
    return {
      pendings: [],
      approved: [],
      vendor_name: "",
      src: [],
      activeClick: true
    };
  },

  methods: {
    async loadProducts() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
      }

      axios
        .get(axios.lpsURL + "/vendor/products?vendor_id=" + id, {
          headers: {
            Authorization: "Bearer " + token
          }
        })
        .then(res => {
          this.pendings = res.data.products.pendings;
          console.log(res.data.products);
          this.approved = res.data.products.approved;
          this.vendor_name = res.data.vendor_name;

          if (this.pendings != null) {
            this.loadPendingImage(token);
          }
          if (this.approved != null) {
            this.loadApprovedImage(token);
          }
        })
        .then(function() {
          $("#pending_tbl").DataTable({
            pageLength: 5,
            dom: "Bfrtip",
            buttons: [
              {
                extend: "excelHtml5",
                exportOptions: {
                  columns: [0, 1, 2, 3, 4, 5, 6, 7]
                }
              },
              {
                extend: "pdfHtml5",
                exportOptions: {
                  columns: [0, 1, 2, 3, 4, 5, 6, 7]
                }
              }
            ]
          });
          $("#approved_tbl").DataTable({
            pageLength: 5,
            dom: "Bfrtip",
            buttons: [
              {
                extend: "excelHtml5",
                exportOptions: {
                  columns: [0, 1, 2, 3, 4, 5, 6, 7]
                }
              },
              {
                extend: "pdfHtml5",
                exportOptions: {
                  columns: [0, 1, 2, 3, 4, 5, 6, 7]
                }
              }
            ]
          });
        });
    },

    loadPendingImage(token) {
      this.pendings.forEach(data => {
        axios
          .get(axios.lpsURL + "/vendor_product/show/" + data.id, {
            headers: {
              Authorization: "Bearer " + token
            },
            responseType: "blob"
          })
          .then(response => {
            let reader = new FileReader();
            reader.readAsDataURL(response.data);
            reader.onload = () => {
              // this.src = reader.result

              let src = {
                id: data.id,
                src: reader.result
              };
              this.src.push(src);
            };
          });
      });
    },

    loadApprovedImage(token) {
      this.approved.forEach(data => {
        axios
          .get(axios.lpsURL + "/vendor_product/show/" + data.id, {
            headers: {
              Authorization: "Bearer " + token
            },
            responseType: "blob"
          })
          .then(response => {
            let reader = new FileReader();
            reader.readAsDataURL(response.data);
            reader.onload = () => {
              // this.src = reader.result

              let src = {
                id: data.id,
                src: reader.result
              };
              this.src.push(src);
            };
          });
      });
    },

    redirect(id) {
      let vendor_id = this.$route.params.id;

      return "/lps/vendor/product/details/" + vendor_id + "/" + id;
    },

    approved1() {
      $("#approved_card").removeClass("d-none");
      $("#pending_card").addClass("d-none");
      this.activeClick = false;
    },

    pending1() {
      $("#pending_card").removeClass("d-none");
      $("#approved_card").addClass("d-none");
      this.activeClick = true;
    },

    loadData() {
      this.destroyDatatable();
      this.loadProducts();
    },

    destroyDatatable() {
      $("#pending_tbl")
        .DataTable()
        .destroy();
      $("#approved_tbl")
        .DataTable()
        .destroy();
    }
  },

  mounted() {
    this.loadData();
  }
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
